import { render, staticRenderFns } from "./AddDocumentReorder.vue?vue&type=template&id=d829ec68&"
import script from "./AddDocumentReorder.vue?vue&type=script&lang=js&"
export * from "./AddDocumentReorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports